export default __webpack_public_path__ + "models/b38e255b719520fb03331951d60e0844.glb";